import {routesNames} from "@/core/constants";
import BaixarDocumentoPedido from "@/views/pages/documento/pedido/BaixarDocumentoPedido.vue";
import BaixarDocumentoAta from "@/views/pages/documento/ata/BaixarDocumentoAta.vue";

export default [
	{
		name: routesNames.DOCUMENTO.BAIXAR.PEDIDO,
		path: '/documento/:idDocumento/baixar/pedido',
		component: BaixarDocumentoPedido,
	},
	{
		name: routesNames.DOCUMENTO.BAIXAR.ATA,
		path: '/documento/:idDocumento/baixar/ata',
		component: BaixarDocumentoAta,
	},
]
